import { render } from "./RiskApplicationReview.vue?vue&type=template&id=78b8155e"
import script from "./RiskApplicationReview.vue?vue&type=script&lang=js"
export * from "./RiskApplicationReview.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__